import React from 'react';
import {Route, Routes} from 'react-router-dom';
import { ReadingTestStart } from './ReadingTestStart';
import ReadingTest from './ReadingTest';
import ReadingTestResult from './ReadingTestResult';

const ReadingTestPage = ()=>{
    return (
        <div className="readingTestPage">
        <Routes>
            <Route path="/" element={ <ReadingTestStart /> } />
            <Route path="/:type" element={ <ReadingTest /> } />
            <Route path="/:id/result" element={ <ReadingTestResult /> } />
        </Routes>
        </div>
    );
}
export default ReadingTestPage;